import { useEffect } from 'react';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import Home from './components/public/Home';
import Contact from './components/public/Contact';
import PageNotFound from './components/public/PageNotFound';

// Privacy policy now lives on the Creator Media Group site
function PrivacyRedirect() {
  useEffect(() => {
    // Skip the redirect during react-snap prerendering - navigating away mid-crawl
    // destroys puppeteer's execution context and fails the CI build.
    if (navigator.userAgent === 'ReactSnap') return;
    window.location.replace('https://wearecreatormedia.com/privacy-policy/');
  }, []);
  return null;
}

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/privacy-policy/" element={<PrivacyRedirect />} />
        <Route path="/privacy" element={<PrivacyRedirect />} />
        <Route path="/contact/" element={<Contact />} />
        <Route path="*" element={<PageNotFound />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
